"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uaResult = exports.uaCheck = exports.isMobileForClient = void 0;
const isMobileForClient = () => {
    if (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) {
        const ua = navigator.userAgent;
        const istablet = /android/i.test(ua) && !/mobile/i.test(ua);
        if (!istablet && /(android)|(iphone)|(ipod)|(iPad.*MicroMessenger)|(IEMobile)|(MIDP)/i.test(ua)) {
            return true;
        }
    }
    return false;
};
exports.isMobileForClient = isMobileForClient;
const check = (ua) => {
    if (!ua) {
        return {};
    }
    const os = {};
    const browser = {};
    const oscheck = {
        iphone: ua.match(/(iphone)\s(os\s)?([\d_]+)/i),
        ipad: ua.match(/(ipad).*\s([\d_]+)/i),
        ipod: ua.match(/(ipod).*\s([\d_]+)/i),
        android: ua.match(/(android)\s([\d.]+)/i),
        windows: ua.match(/Windows(\s+\w+)?\s+?(\d+\.\d+)/),
        macos: ua.match(/(Mac\sOS\s?(\w{1,2}\s)?([\d_]+))/i),
    };
    if (oscheck.ipod) {
        // eslint-disable-next-line no-multi-assign
        os.ios = os.ipod = true;
        os.version = oscheck.ipod[2].replace(/_/g, '.');
        os.name = 'ipod';
    }
    if (oscheck.ipad) {
        // eslint-disable-next-line no-multi-assign
        os.ios = os.ipad = true;
        os.version = oscheck.ipad[2].replace(/_/g, '.');
        os.name = 'ipad';
    }
    if (oscheck.iphone) {
        // eslint-disable-next-line no-multi-assign
        os.iphone = os.ios = true;
        os.version = oscheck.iphone[3].replace(/_/g, '.');
        os.name = 'iphone';
        os.isMobile = true;
    }
    if (oscheck.android) {
        os.android = true;
        os.version = oscheck.android[2];
        os.name = 'android';
        os.isMobile = true;
    }
    if (oscheck.windows) {
        os.windows = true;
        os.version = oscheck.windows[2];
        os.name = 'windows';
    }
    if (oscheck.macos) {
        os.macos = true;
        os.version = oscheck.macos[3].replace(/_/g, '.');
        os.name = 'MacOS';
    }
    // 移动端APP的ua可能会有MQQBrowser、Chrome的关键字，为确保判断准确，关键字判断请尽量放在他们之前。
    const browserCheck = {
        IE: ua.match(/; msie\b|; trident\b|\bedge\//i),
        IEMobile: ua.match(/IEMobile(\/|\s+)(\d+\.\d+)/) || ua.match(/WPDesktop/),
        Chrome: os.ios ? ua.match(/CriOS\/(\d+\.\d+)/) : ua.match(/Chrome\/(\d+\.\d+)/),
        Safari: (os.macos || os.ios) ? ua.match(/Safari\/(\d+\.\d+\.\d+)/) : false,
        Firefox: ua.match(/Firefox\/(\d+\.\d+)/i),
    };
    Object.keys(browserCheck).some((v) => {
        if (browserCheck[v]) {
            browser[v] = true;
            browser.version = browserCheck[v][1] || 0;
            browser.name = v;
            return browserCheck[v];
        }
        return false;
    });
    return {
        browser,
        os,
    };
};
let browserCache;
const uaCheck = () => browserCache || (browserCache = check(navigator.userAgent));
exports.uaCheck = uaCheck;
exports.uaResult = exports.uaCheck();
